import React, { useEffect, useState, useRef, useContext } from "react";
import Logo from "../../images/MY-Anlook.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import MyContext from "../../MyContext";

const Navbar = () => {
  const { baseUrl, config } = useContext(MyContext);
  const navigate = useNavigate();

  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuWrapperRef = useRef(null);

  const [plans, setPlans] = useState([]);
  const [sessionID, setSessionId] = useState("");
  const [campaignIdHook, setCampaignIdHook] = useState("");

  /* =========================
     SCROLL EFFECT
  ========================== */
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* =========================
     OUTSIDE CLICK CLOSE
  ========================== */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        menuWrapperRef.current &&
        !menuWrapperRef.current.contains(e.target)
      ) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  /* =========================
     SESSION ID
  ========================== */
  const generateUUID = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  };

  useEffect(() => {
    const storedSessionID = sessionStorage.getItem("sessionID");
    if (storedSessionID) {
      setSessionId(storedSessionID);
    } else {
      const newSessionID = generateUUID();
      sessionStorage.setItem("sessionID", newSessionID);
      setSessionId(newSessionID);
    }
  }, []);

  /* =========================
     CAMPAIGN ID
  ========================== */
  useEffect(() => {
    let params = new URLSearchParams(window.location.search);
    let campaignid = params.get("campaignid");

    if (!campaignid) {
      params = new URLSearchParams(window.location.hash.substring(1));
      campaignid = params.get("campaignid");
    }

    if (campaignid) {
      sessionStorage.setItem("campaignId", campaignid);
      setCampaignIdHook(campaignid);
    }
  }, []);

  /* =========================
     FETCH PLANS
  ========================== */
  const fetchSubscriptionPlans = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Entitlement/fetchSubscriptionPlans`,
        { userid: "", countryCode: "IN" },
        config
      );
      setPlans(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };

  useEffect(() => {
    if (sessionID) {
      fetchSubscriptionPlans();
    }
  }, [sessionID]);

  /* =========================
     SEO TRACK
  ========================== */
  const trackClick = async (buttonName) => {
    try {
      const requestBody = {
        campaignid: campaignIdHook,
        sessionid: sessionID,
        element: "Button",
        button_name: buttonName,
        pageurl: window.location.href,
        pagename: "Navbar",
        product: "Anlook",
      };

      await axios.post(`${baseUrl}/api/Blog/trackClickHeatMaps`, requestBody);
    } catch (error) {
      console.error("SEO track error:", error);
    }
  };

  const handleGetStarted = async () => {
    await trackClick("Get Started");

    navigate("/get/GetStarted", {
      state: {
        plan: plans,
      },
    });
  };

  return (
    <>
      <div className={`ln-wrap ${scrolled ? "scrolled" : ""}`}>
        <div className="ln-container">
          <div className="ln-inner" ref={menuWrapperRef}>
            {/* LOGO */}
            <Link to="/get">
              <img src={Logo} alt="Logo" className="ln-logo" />
            </Link>

            {/* DESKTOP LINKS */}
            <div className="ln-links">
              <Link to="/get" className="ln-link">
                Home
              </Link>
              <Link to="/about-us" className="ln-link">
                About
              </Link>
              <Link to="/pricing-page" className="ln-link">
                Pricing
              </Link>
            </div>

            {/* RIGHT */}
            <div style={{ display: "flex", alignItems: "center" }}>
              <button
                className="ln-btn ln-login-desktop"
                onClick={handleGetStarted}
              >
                Get Started
              </button>

              <div
                className="ln-hamburger"
                onClick={() => setMenuOpen(!menuOpen)}
              >
                ☰
              </div>
            </div>

            {/* MOBILE MENU */}
            {menuOpen && (
              <div className="ln-mobile-menu">
                <Link to="/get" onClick={() => setMenuOpen(false)}>
                  Home
                </Link>
                <Link to="/about-us" onClick={() => setMenuOpen(false)}>
                  About
                </Link>
                <Link to="/pricing-page" onClick={() => setMenuOpen(false)}>
                  Pricing
                </Link>
                <button
                  className="ln-btn"
                  onClick={() => {
                    setMenuOpen(false);
                    handleGetStarted();
                  }}
                >
                  Get Started
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <style>{`
        .ln-wrap {
          position: sticky;
          top: 0;
          height: 75px;
          background: #F1F5F1;
          display: flex;
          align-items: center;
          z-index: 1000;
        }

        .ln-wrap.scrolled {
          background: #F1F5F1;
        }

        .ln-container {
          max-width: 1400px;
          width: 100%;
          margin: 0 auto;
          padding: 0 5rem;
        }

        .ln-inner {
          height: 75px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .ln-logo {
          width: 160px;
          cursor: pointer;
        }

        .ln-links {
          display: flex;
          gap: 32px;
        }

        .ln-link {
          font-weight: 500;
          color: #2c2c2c;
          cursor: pointer;
          text-decoration: none;
        }

        .ln-btn {
          border-radius: 8px;
          border: none;
          padding: 8px 22px;
          height: 40px;
          font-weight: 600;
          background: #01C37D;
          color: #fff;
          cursor: pointer;
        }

        .ln-hamburger {
          display: none;
          font-size: 26px;
          cursor: pointer;
        }

        .ln-mobile-menu {
          position: fixed;
          top: 75px;
          left: 0;
          width: 100vw;
          background: white;
          padding: 20px;
          text-align: center;
          box-shadow: 0 10px 25px rgba(0,0,0,0.08);
          z-index: 999;
        }

        .ln-mobile-menu a {
          display: block;
          padding: 13px 0;
          font-size: 18px;
          color: #141414;
          text-decoration: none;
        }

        @media (max-width: 992px) {
          .ln-links { display: none; }
          .ln-hamburger { display: block; }
          .ln-login-desktop { display: none; }
          .ln-container { padding: 0 2rem; }
        }
      `}</style>
    </>
  );
};

export default Navbar;
